import initialState from "./treePermit.state.js";
import actions from "./treePermit.actions.js";
import mutations from "./treePermit.mutations.js";
import getters from "./treePermit.getters.js";

export default {
  state: initialState,
  actions,
  mutations,
  getters
};
